import { type BoxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  StyledTagsGridItemImage,
  StyledDiscoveryTile,
  StyledInner,
} from './styled';

interface DiscoveryTileProps extends BoxProps {
  image: string;
}

const DiscoveryTile = ({ children, image, ...props }: DiscoveryTileProps) => {
  const { t } = useTranslation();

  return (
    <StyledDiscoveryTile label={t('discoveryPage:generate')} {...props}>
      <StyledTagsGridItemImage src={image} />
      <StyledInner>{children}</StyledInner>
    </StyledDiscoveryTile>
  );
};

export default DiscoveryTile;
